import { render, staticRenderFns } from "./VerPedidoItems.vue?vue&type=template&id=f5afcc5e&scoped=true&"
import script from "./VerPedidoItems.vue?vue&type=script&lang=js&"
export * from "./VerPedidoItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5afcc5e",
  null
  
)

export default component.exports